import classnames from 'classnames';
import Image from 'next/legacy/image';
import vholsLogo from 'src/assets/images/logos/virgin-atlantic-holidays.svg';
import vaaLogo from 'src/assets/images/logos/virgin-atlantic.svg';
import { BRAND_NAMES } from 'src/utils/brand';
import { hardRedirectTo } from 'src/utils/navigation';
import styles from './logo-bar.component.module.less';

const LogoBar = () => {
  const logo = vaaLogo.src;
  const altText = BRAND_NAMES.VAA;

  return (
    <div className={classnames(styles['logo-bar'])}>
      <div className={styles.logo}>
        <Image
          priority
          src={logo}
          alt={altText}
          objectFit="cover"
          layout="fill"
          style={{ cursor: 'pointer' }}
          onClick={() => hardRedirectTo('/')}
        />
      </div>
    </div>
  );
};

export default LogoBar;
